import styled from 'styled-components';

export const ActivitiesContainer = styled.div`
  .title-wrapper {
    margin-bottom: 18px;

    button {
      min-width: fit-content;
    }
  }
`;
